// src/contexts/ThemeContext.js
import React, { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");

  // Load saved theme from localStorage (runs only on first render)
  useEffect(() => {
    const saved = localStorage.getItem("app-theme");
    if (saved) setTheme(saved);
  }, []);

  // Apply theme to body and save to localStorage
  useEffect(() => {
    document.body.className = ""; // reset
    document.body.classList.add(theme); // apply new theme
    localStorage.setItem("app-theme", theme); // persist
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
